import React from 'react'
import { useDispatch } from 'react-redux'
import { styles } from './styles.js'
import { authorization } from '../../../Module/Auth/Auth'
import { makeStyles } from '@material-ui/core'
import { userLogout } from '../../../Reducers/Auth/actions.js'

const useStyles = makeStyles(styles)

export const AuthErrorModal = () => {
  const dispatch = useDispatch()
  const redirectUrl = '/login'
  const classes = useStyles()

  const handleConfirm = () => {
    if (redirectUrl) {
      dispatch(userLogout())
      authorization.logout()
      window.location.href = redirectUrl
    }
  }

  return (
    <div className={classes.modalWrapper}>
      <div className={classes.modalContent}>
        <h2 className={classes.modalH2}>Heads-up!</h2>
        <p className={classes.modalText}>
          We've made some improvements to our authentication system. To ensure a
          smooth experience, please log out and log back in.
        </p>
        <button className={classes.modalButton} onClick={handleConfirm}>
          OK
        </button>
      </div>
    </div>
  )
}
